import cookie from 'js-cookie'

const isStudent = cookie.get('user_type') && JSON.parse(cookie.get('user_type')).includes('student')
const IS_PROD = process.env.NODE_ENV === 'production'

const teachingPlanProd = {

  id: '2a763f3e-a6d9-4694-8d69-23558da56d79',
  name: '智能教案撰写',
  type: 'teachingPlan',
  desc: '按需定制，生成教案',
  img: require('@/assets/icons/ja.png'),
  content: []
}
const courseProd = {
  id: 'b6107a82-c25b-4ede-80bd-3c8da1e8d56f',
  name: '智能课程生成',
  type: 'course',
  desc: '按需输入，智能生成',
  img: require('@/assets/icons/kc.png'),
  content: []
}
const appProd = [{
  name: '学习',
  children: [
    {
      id: 'fb5c0af8-43c5-416b-951c-d7b2e9907536',
      name: '要点背诵',
      desc: 'AI提炼，辅助背诵',
      img: require('@/assets/icons/yd.png'),
      content: [{
        text: '请输入提炼的内容'
      }, {
        placeholder: '[需要提炼的内容]'
      }, {
        text: '，提炼要求是'
      }, {
        placeholder: '[输入要点字数、详细内容的要求等]'
      }, {
        text: '。'
      }]
    },
    {
      id: 'deb2b805-2945-4220-a24d-2357c822217c',
      name: '论文总结',
      desc: '选定论文，提炼要点',
      img: require('@/assets/icons/lw.png'),
      content: [{
        text: '请输入论文的内容'
      }, {
        placeholder: '[论文具体内容]'
      }, {
        text: '，提炼要点要求是'
      }, {
        placeholder: '[输入提炼研究目的、创新之处等]'
      }, {
        text: '。'
      }]
    },
    {
      id: '93d79bf1-0d23-4b00-b50e-14a9e9e9d10f',
      name: '考研英语学习助手',
      desc: '智能规划，考研无忧',
      img: require('@/assets/icons/icon_ky.png'),
      content: [{
        text: '请输入学习目标'
      }, {
        placeholder: '[期待达到的学习目标分数]'
      }, {
        text: '，个人学习情况的说明'
      }, {
        placeholder: '[输入个人学习情况，如可学习时长、弱项重点等]'
      }, {
        text: '。'
      }]
    },
    {
      id: 'f6454bb0-674d-445a-a247-2f1576908a14',
      name: '四六级英语学习助手',
      desc: '智能规划，高分过线',
      img: require('@/assets/icons/icon_get.png'),
      content: [{
        text: '请输入学习目标'
      }, {
        placeholder: '[期待达到的学习目标分数]'
      }, {
        text: '，个人学习情况的说明'
      }, {
        placeholder: '[输入个人学习情况，如可学习时长、弱项重点等]'
      }, {
        text: '。'
      }]
    },
    {
      id: 'dda37840-4e51-4caf-8b7d-454c001b0c58',
      name: '雅思英语学习助手',
      desc: '智能备考，一站突破',
      img: require('@/assets/icons/icon_ys.png'),
      content: [{
        text: '请输入学习目标'
      }, {
        placeholder: '[期待达到的学习目标分数]'
      }, {
        text: '，个人学习情况的说明'
      }, {
        placeholder: '[输入个人学习情况，如可学习时长、弱项重点等]'
      }, {
        text: '。'
      }]
    },
    {
      id: '4e9f1e7b-ce18-4700-a805-fd3360d9a3d7',
      name: '学习辩论',
      desc: '针对主题，与AI辩',
      img: require('@/assets/icons/icon_bl.png'),
      content: [{
        text: '请输入辩论主题'
      }, {
        placeholder: '[期待探讨的辩论主题]'
      }, {
        text: '，辩论要求是'
      }, {
        placeholder: '[输入辩论的要求，如时间限制、正反方设置、对话次数等]'
      }, {
        text: '。'
      }]
    },
    {
      id: 'ffc4412f-c634-430e-b6fe-3031095b7a0b',
      name: '智能学习助手',
      desc: '智能规划，高效学习',
      img: require('@/assets/icons/icon_znxx.png'),
      content: [{
        text: '请输入学习目标'
      }, {
        placeholder: '[期待达到的学习目标分数]'
      }, {
        text: '，学习要求是'
      }, {
        placeholder: '[输入学习的要求，如目标分数、基础水平、学习重点等]'
      }, {
        text: '。'
      }]
    },
    {
      id: '76840a1b-aca8-471d-8e5b-315fcf6e928e',
      name: 'AI面试官',
      desc: '模拟面试，精准反馈',
      img: require('@/assets/icons/icon_ai.png'),
      content: [{
        text: '请输入应聘的岗位'
      }, {
        placeholder: '[期待应聘的岗位]'
      }, {
        text: '，应聘的要求是'
      }, {
        placeholder: '[输入应聘的要求，如行业背景、经验水平、技能需求等]'
      }, {
        text: '。'
      }]
    }
  ]
}, {
  name: '科研',
  children: [
    {
      id: '6ce2ae29-e083-423b-b309-920c106419c1',
      name: '写作润色(中/英)助手',
      desc: '优化论文，中英皆可',
      img: require('@/assets/icons/icon_rs.png'),
      content: [{
        text: '请输入润色的内容'
      }, {
        placeholder: '[需要润色的内容]'
      }, {
        text: '，润色要求是'
      }, {
        placeholder: '[输入润色的要求，如风格、字数要求等]'
      }, {
        text: '。'
      }]
    },
    {
      id: '98755c0a-0089-4b60-8e63-bce508e857d3',
      name: '改写降重助手',
      desc: '输入段落，改写降重',
      img: require('@/assets/icons/icon_gx.png'),
      content: [{
        text: '请输入改写的内容'
      }, {
        placeholder: '[需要改写降重的内容]'
      }, {
        text: '，改写要求是'
      }, {
        placeholder: '[输入要改写的重点或要求，如风格调整、信息更新、字数要求]'
      }, {
        text: '。'
      }]
    },
    {
      id: '9f618bef-ef25-461f-b594-076906428f39',
      name: '论文大纲生成',
      desc: '智能提纲，高效写作',
      img: require('@/assets/icons/lw.png'),
      content: [{
        text: '请输入论文题目'
      }, {
        placeholder: '[需要生成提纲的论文主题]'
      }, {
        text: '，请输入论文学科领域'
      }, {
        placeholder: '[论文的学科领域]'
      }, {
        text: '，大纲要求是'
      }, {
        placeholder: '[输入大纲的要求，如结构层级、研究方向、格式规范等]'
      }, {
        text: '。'
      }]
    },
    {
      id: 'f15d1348-f61e-4f75-a613-041a34c63a2f',
      name: '科技术语翻译',
      desc: '专业术语，精准翻译',
      img: require('@/assets/icons/sy.png'),
      content: [{
        text: '请输入待翻译文本'
      }, {
        placeholder: '[需要翻译的文本]'
      }, {
        text: '，请输入文本所属学科领域'
      }, {
        placeholder: '[需要翻译文本的学科领域]'
      }, {
        text: '，翻译要求是'
      }, {
        placeholder: '[输入翻译的要求，如目标语种、格式规范等]'
      }, {
        text: '。'
      }]
    },
    {
      id: 'a2bfbb75-9cb4-43f1-9d86-2d0e52e38a36',
      name: '文章撰写助手',
      desc: '助力科研，高效成文',
      img: require('@/assets/icons/icon_wz.png'),
      content: [{
        text: '请输入文章主题'
      }, {
        placeholder: '[需要撰写的文章主题]'
      }, {
        text: '，请输入文本学科领域'
      }, {
        placeholder: '[需要撰写文章的学科领域]'
      }, {
        text: '，文章生成要求是'
      }, {
        placeholder: '[输入文章生成的要求，如文章类型、研究重点、格式规范、字数要求等]'
      }, {
        text: '。'
      }]
    },
    {
      id: '40b83b19-7f26-42f6-9e2e-0150267b5226',
      name: '互译(中/英)助手',
      desc: '快速互译，精准沟通',
      img: require('@/assets/icons/icon_hy.png'),
      content: [{
        text: '请输入待翻译文本'
      }, {
        placeholder: '[需要翻译的文本]'
      }, {
        text: '，翻译要求是'
      }, {
        placeholder: '[输入翻译的要求，如格式规范、字数要求等]'
      }, {
        text: '。'
      }]
    },
    {
      id: '88eba25b-1cae-4d4c-8fc9-70455f44848f',
      name: '提升段落逻辑和连贯性助手',
      desc: '优化结构，增强逻辑',
      img: require('@/assets/icons/ts.png'),
      content: [{
        text: '请输入待优化的文本'
      }, {
        placeholder: '[需要优化的文本]'
      }, {
        text: '，请输入文本学科领域'
      }, {
        placeholder: '[待优化文本学科领域]'
      }, {
        text: '，优化要求是'
      }, {
        placeholder: '[输入优化的要求，如优化目标、目标语种、格式规范等]'
      }, {
        text: '。'
      }]
    }
  ]
}]
const teachingPlanTest = {

  id: '58e5f389-22d5-4125-8b71-77b88e170b02',
  name: '智能教案撰写',
  type: 'teachingPlan',
  desc: '按需定制，生成教案',
  img: require('@/assets/icons/ja.png'),
  content: []
}
const courseTest = {
  id: '40e15055-d0a3-4a86-97ad-44317388db58',
  name: '智能课程生成',
  type: 'course',
  desc: '按需输入，智能生成',
  img: require('@/assets/icons/kc.png'),
  content: []
}

// const teacher = isStudent ? {} : 
const appTest = [{
  name: '学习',
  children: [
    {
      id: '5900bbbd-f071-4641-b2ba-c1cc49e8c694',
      name: '要点背诵',
      desc: 'AI提炼，辅助背诵',
      img: require('@/assets/icons/yd.png'),
      content: [{
        text: '请输入提炼的内容'
      }, {
        placeholder: '[需要提炼的内容]'
      }, {
        text: '，提炼要求是'
      }, {
        placeholder: '[输入要点字数、详细内容的要求等]'
      }, {
        text: '。'
      }]
    },
    {
      id: 'b8af3f86-9243-480e-bec8-c9a072d1e9e5',
      name: '论文总结',
      desc: '选定论文，提炼要点',
      img: require('@/assets/icons/lw.png'),
      content: [{
        text: '请输入论文的内容'
      }, {
        placeholder: '[论文具体内容]'
      }, {
        text: '，提炼要点要求是'
      }, {
        placeholder: '[输入提炼研究目的、创新之处等]'
      }, {
        text: '。'
      }]
    },
    {
      id: '9e65c2c9-d9e5-485b-9abf-3fd6c4bd4093',
      name: '考研英语学习助手',
      desc: '智能规划，考研无忧',
      img: require('@/assets/icons/icon_ky.png'),
      content: [{
        text: '请输入学习目标'
      }, {
        placeholder: '[期待达到的学习目标分数]'
      }, {
        text: '，个人学习情况的说明'
      }, {
        placeholder: '[输入个人学习情况，如可学习时长、弱项重点等]'
      }, {
        text: '。'
      }]
    },
    {
      id: 'b329909f-99f1-4a91-9009-d94c7d7a2ec0',
      name: '四六级英语学习助手',
      desc: '智能规划，高分过线',
      img: require('@/assets/icons/icon_get.png'),
      content: [{
        text: '请输入学习目标'
      }, {
        placeholder: '[期待达到的学习目标分数]'
      }, {
        text: '，个人学习情况的说明'
      }, {
        placeholder: '[输入个人学习情况，如可学习时长、弱项重点等]'
      }, {
        text: '。'
      }]
    },
    {
      id: '5de0f4c5-6491-4fab-9c70-ee5350881e60',
      name: '雅思英语学习助手',
      desc: '智能备考，一站突破',
      img: require('@/assets/icons/icon_ys.png'),
      content: [{
        text: '请输入学习目标'
      }, {
        placeholder: '[期待达到的学习目标分数]'
      }, {
        text: '，个人学习情况的说明'
      }, {
        placeholder: '[输入个人学习情况，如可学习时长、弱项重点等]'
      }, {
        text: '。'
      }]
    },
    {
      id: 'e7ce2031-0d4d-4d36-8f7a-acec57479041',
      name: '学习辩论',
      desc: '针对主题，与AI辩',
      img: require('@/assets/icons/icon_bl.png'),
      content: [{
        text: '请输入辩论主题'
      }, {
        placeholder: '[期待探讨的辩论主题]'
      }, {
        text: '，辩论要求是'
      }, {
        placeholder: '[输入辩论的要求，如时间限制、正反方设置、对话次数等]'
      }, {
        text: '。'
      }]
    },
    {
      id: '949ab7e9-b686-4406-8c5b-9fc644e91577',
      name: '智能学习助手',
      desc: '智能规划，高效学习',
      img: require('@/assets/icons/icon_znxx.png'),
      content: [{
        text: '请输入学习目标'
      }, {
        placeholder: '[期待达到的学习目标分数]'
      }, {
        text: '，学习要求是'
      }, {
        placeholder: '[输入学习的要求，如目标分数、基础水平、学习重点等]'
      }, {
        text: '。'
      }]
    },
    {
      id: 'c179e401-3841-4c39-9119-95018ff21960',
      name: 'AI面试官',
      desc: '模拟面试，精准反馈',
      img: require('@/assets/icons/icon_ai.png'),
      content: [{
        text: '请输入应聘的岗位'
      }, {
        placeholder: '[期待应聘的岗位]'
      }, {
        text: '，应聘的要求是'
      }, {
        placeholder: '[输入应聘的要求，如行业背景、经验水平、技能需求等]'
      }, {
        text: '。'
      }]
    }
  ]
}, {
  name: '科研',
  children: [
    {
      id: 'c1172a25-e230-4cfd-9713-985f965b7be0',
      name: '写作润色(中/英)助手',
      desc: '优化论文，中英皆可',
      img: require('@/assets/icons/icon_rs.png'),
      content: [{
        text: '请输入润色的内容'
      }, {
        placeholder: '[需要润色的内容]'
      }, {
        text: '，润色要求是'
      }, {
        placeholder: '[输入润色的要求，如风格、字数要求等]'
      }, {
        text: '。'
      }]
    },
    {
      id: 'bfd57865-cb27-4f8b-9f9f-5240dc95c652',
      name: '改写降重助手',
      desc: '输入段落，改写降重',
      img: require('@/assets/icons/icon_gx.png'),
      content: [{
        text: '请输入改写的内容'
      }, {
        placeholder: '[需要改写降重的内容]'
      }, {
        text: '，改写要求是'
      }, {
        placeholder: '[输入要改写的重点或要求，如风格调整、信息更新、字数要求]'
      }, {
        text: '。'
      }]
    },
    {
      id: '2a52243d-9350-42ef-b5c2-3fba292141c2',
      name: '论文大纲生成',
      desc: '智能提纲，高效写作',
      img: require('@/assets/icons/lw.png'),
      content: [{
        text: '请输入论文题目'
      }, {
        placeholder: '[需要生成提纲的论文主题]'
      }, {
        text: '，请输入论文学科领域'
      }, {
        placeholder: '[论文的学科领域]'
      }, {
        text: '，大纲要求是'
      }, {
        placeholder: '[输入大纲的要求，如结构层级、研究方向、格式规范等]'
      }, {
        text: '。'
      }]
    },
    {
      id: '6cdfa5b4-bd6d-45f4-a6cf-b32669949dc3',
      name: '科技术语翻译',
      desc: '专业术语，精准翻译',
      img: require('@/assets/icons/sy.png'),
      content: [{
        text: '请输入待翻译文本'
      }, {
        placeholder: '[需要翻译的文本]'
      }, {
        text: '，请输入文本所属学科领域'
      }, {
        placeholder: '[需要翻译文本的学科领域]'
      }, {
        text: '，翻译要求是'
      }, {
        placeholder: '[输入翻译的要求，如目标语种、格式规范等]'
      }, {
        text: '。'
      }]
    },
    {
      id: '052cc20e-304c-487a-a090-e829d6a1f483',
      name: '文章撰写助手',
      desc: '助力科研，高效成文',
      img: require('@/assets/icons/icon_wz.png'),
      content: [{
        text: '请输入文章主题'
      }, {
        placeholder: '[需要撰写的文章主题]'
      }, {
        text: '，请输入文本学科领域'
      }, {
        placeholder: '[需要撰写文章的学科领域]'
      }, {
        text: '，文章生成要求是'
      }, {
        placeholder: '[输入文章生成的要求，如文章类型、研究重点、格式规范、字数要求等]'
      }, {
        text: '。'
      }]
    },
    {
      id: '9b5e9fa1-42f8-449a-9dfd-f07dc9a86e3b',
      name: '互译(中/英)助手',
      desc: '快速互译，精准沟通',
      img: require('@/assets/icons/icon_hy.png'),
      content: [{
        text: '请输入待翻译文本'
      }, {
        placeholder: '[需要翻译的文本]'
      }, {
        text: '，翻译要求是'
      }, {
        placeholder: '[输入翻译的要求，如格式规范、字数要求等]'
      }, {
        text: '。'
      }]
    },
    {
      id: 'f28f7960-9532-4deb-862e-d8c39fc08a67',
      name: '提升段落逻辑和连贯性助手',
      desc: '优化结构，增强逻辑',
      img: require('@/assets/icons/ts.png'),
      content: [{
        text: '请输入待优化的文本'
      }, {
        placeholder: '[需要优化的文本]'
      }, {
        text: '，请输入文本学科领域'
      }, {
        placeholder: '[待优化文本学科领域]'
      }, {
        text: '，优化要求是'
      }, {
        placeholder: '[输入优化的要求，如优化目标、目标语种、格式规范等]'
      }, {
        text: '。'
      }]
    }
  ]
}]
if (!isStudent) {
  appTest.unshift({
    name: '课程',
    children: [
      teachingPlanTest,
      courseTest
    ]
  })
  appProd.unshift({
    name: '课程',
    children: [
      teachingPlanProd,
      courseProd
    ]
  })
}

// 知识库信息
const dataSetProd = {
  id: '8543e367-3e37-454b-af21-d7505c078835',
  name: '知识库'
}
const dataSetTest = {
  id: '69600add-ac2c-4aa7-b84f-a40e152d3be1',
  name: '知识库'
}

export const baseApp = IS_PROD ? { name: '基础问答', id: 'f5e4faea-739c-409b-9431-b2a5b8edcf1b' } : { name: '基础问答', id: '4b9113f8-1ccb-4429-bf4e-154ec7dcbade' }
export const teachingPlan = IS_PROD ? teachingPlanProd : teachingPlanTest
export const course = IS_PROD ? courseProd : courseTest
export const app = IS_PROD ? appProd : appTest
export const dataSet = IS_PROD ? dataSetProd : dataSetTest
